import { Component, input, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { cn } from "../utils/utils";
import { injectChatLabels } from "../core/chat-labels";

@Component({
  selector: "agent-chat-view-disclaimer",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div [class]="computedClass">
      {{ disclaimerText }}
    </div>
  `,
})
export class AgentChatViewDisclaimer {
  inputClass = input<string | undefined>();

  text = input<string | undefined>();

  readonly labels = injectChatLabels();

  get disclaimerText(): string {
    if (this.text()) {
      return this.text() as string;
    }
    return this.labels.chatDisclaimerText;
  }

  get computedClass(): string {
    return cn("achat-disclaimer", this.inputClass());
  }
}
